import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=470e143a"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports